import React from 'react'
import PropTypes from 'prop-types'
import withExperimentProvider from 'components/hocs/withExperimentProvider'
import Variation from '@cred/react-experiments/variation'
import RichCta from 'components/rich-cta'
import config from 'config'
import { PERSONAL_INTERACTIVE_ANIMATED_WIDGET_EXPERIMENT_ID } from 'experiments/vtConfig'
import PersonalLoanForm from 'components/form/personal'
import WidgetPage from 'components/hocs/widget-page'
import PersonalAnimatedCta from './animated-cta'

const RichCtaApp = ({ utms, ...props }) => (
  <>
    <Variation experimentId={PERSONAL_INTERACTIVE_ANIMATED_WIDGET_EXPERIMENT_ID} id={0}>
      <RichCta
        url={`${config.credibleRoot}/personal-loan-prequalification`}
        formUrl={`${config.credibleRoot}/personal-loans/borrower`}
        title="Compare personal loan rates from top lenders"
        body="Loans for paying off credit cards, debt consolidation, home improvement and more."
        ctaText="Get Started"
        form={PersonalLoanForm}
        utms={utms}
        {...props}
      />
    </Variation>
    <Variation experimentId={PERSONAL_INTERACTIVE_ANIMATED_WIDGET_EXPERIMENT_ID} id={1}>
      <PersonalAnimatedCta utms={utms} />
    </Variation>
  </>
)

RichCtaApp.propTypes = {
  utms: PropTypes.object,
}

export default withExperimentProvider(WidgetPage(RichCtaApp))
